import {Grid, styled, Typography} from "@mui/material"
import React from "react"

const StyledGrid = styled(Grid)(({theme}) => theme.ICONCARD.container)
const StyledTypo = styled(Typography)(({theme}) => theme.ICONCARD.label)

const IconCardWidget = ({widget: inputWidget,value, triggerAction}) => {
    const widget = {...inputWidget, ...(value?.dataType === "widget" ? value : {})}
        

    const handleClick = () => {
        widget.action && triggerAction(widget.action, widget.target)
    }

    return (
        <StyledGrid
            container
            onClick={handleClick}>
            <div
                style={{
                    padding: "8px",
                }}>
                {widget.icon ? (
                    <img
                        src={
                            window._env_.ARBEITSKONSOLE_SERVER_URL + widget.icon
                        }
                        alt={widget.label}
                        width="80px"
                        height="80px"
                    />
                ) : (
                    <></>
                )}
            </div>

            <StyledTypo
                >
                {widget?.label}
            </StyledTypo>
        </StyledGrid>
    )
}

export default IconCardWidget
